import React from 'react';
import TaskButton from '../TaskButton';
import { Grid, Menu, Button, Dropdown, Segment, Input } from 'semantic-ui-react';
import { compose, withApollo } from 'react-apollo';
import StatesDropdown from '../dropdowns/StatesDropdown';
import SelectedFiltersLabels from '../SelectedFiltersLabels';
import PassengerEmailDropdown from '../dropdowns/PassengerEmailDropdown';
import withTaskTypeOptions from './withTaskTypesOptions';
import withTaskStateOptions from './withTaskStatesOptions';
import withTaskPrioritiesOptions from './withTaskPrioritiesOptions';
import AssigneeFilter from './AssigneeFilter';

const TasksFilters = ({
  taskTypeOptions,
  taskStateOptions,
  statesLoading,
  typesLoading,
  taskPrioritiesOptions,
  prioritiesLoading,
  onFilterAdd,
  onApply,
  onClear,
  filters,
  onFilterDelete,
  onBooleanFilterChange,
  withAssigneFilter,
}) => {
  const labelProps = {
    filters,
    onFilterDelete,
    onBooleanFilterChange,
  };

  const handleEnterPress = e => {
    const { name, value } = e.target;
    if (e.key === 'Enter' && value !== '') onFilterAdd(name, e, { value });
  };

  return (
    <Segment basic>
      <Menu.Item>
        <TaskButton />
      </Menu.Item>
      <Menu.Item>
        <Menu.Header>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column verticalAlign="middle">Filter</Grid.Column>
              <Grid.Column textAlign="right">
                <Button basic size="mini" color="red" onClick={onClear}>
                  Clear Filters
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Menu.Header>
        <Menu.Menu>
          {withAssigneFilter && (
            <AssigneeFilter
              assigneeIds={filters.assigneeIds}
              onFilterDelete={onFilterDelete}
              onFilterAdd={onFilterAdd}
            />
          )}
          <Menu.Item>Claim status</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="claimStatuses" {...labelProps} />
            <StatesDropdown value={null} onChange={onFilterAdd.bind(this, 'claimStatuses')} />
          </Menu.Item>
          <Menu.Item>Task type</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="taskTypes" {...labelProps} />
            <Dropdown
              fluid
              search
              selection
              onChange={onFilterAdd.bind(this, 'taskTypes')}
              options={taskTypeOptions}
              value={null}
              loading={typesLoading}
            />
          </Menu.Item>
          <Menu.Item>Task status</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="taskStatuses" {...labelProps} />
            <Dropdown
              fluid
              selection
              onChange={onFilterAdd.bind(this, 'taskStatuses')}
              options={taskStateOptions}
              value={null}
              loading={statesLoading}
            />
          </Menu.Item>
          <Menu.Item>Task priority</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="taskPriorities" {...labelProps} />
            <Dropdown
              fluid
              selection
              onChange={onFilterAdd.bind(this, 'taskPriorities')}
              options={taskPrioritiesOptions}
              value={null}
              loading={prioritiesLoading}
            />
          </Menu.Item>
          <Menu.Item>PAX email address</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="passengerEmails" {...labelProps} />
            <PassengerEmailDropdown
              upward
              value={null}
              onChange={onFilterAdd.bind(this, 'passengerEmails')}
            />
          </Menu.Item>
          <Menu.Item>PAX Full Name</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="passengerFullNames" {...labelProps} />
            <Input name="passengerFullNames" onKeyPress={handleEnterPress} />
          </Menu.Item>
          <Menu.Item>Claim ID</Menu.Item>
          <Menu.Item>
            <SelectedFiltersLabels filter="claimIds" {...labelProps} />
            <Input name="claimIds" onKeyPress={handleEnterPress} />
          </Menu.Item>
          <Menu.Item style={{ textAlign: 'center' }}>
            <Button primary onClick={onApply}>
              Apply
            </Button>
          </Menu.Item>
        </Menu.Menu>
      </Menu.Item>
    </Segment>
  );
};

const TasksFiltersWithData = compose(
  withApollo,
  withTaskTypeOptions(),
  withTaskStateOptions,
  withTaskPrioritiesOptions
)(TasksFilters);

const TasksFiltersWithAssignee = props => <TasksFiltersWithData {...props} withAssigneFilter />;
export { TasksFiltersWithAssignee };
export default TasksFiltersWithData;



// WEBPACK FOOTER //
// ./src/component/TasksListComponents/TasksFilters.js